import { create } from 'zustand';

export type Tab = 'feed' | 'shelf' | 'topics' | 'friends' | 'profile';
export type CurrencyMode = 'crypto' | 'card';

export const TON_USD_RATE = 5;

const CURRENCY_KEY = 'lura.currency_mode';

function loadCurrencyMode(): CurrencyMode {
  try {
    const v = localStorage.getItem(CURRENCY_KEY);
    if (v === 'card' || v === 'crypto') return v;
  } catch { /* ignore */ }
  return 'crypto';
}

interface UIState {
  activeTab: Tab;
  setActiveTab: (t: Tab) => void;
  toast: { message: string; type: 'info' | 'success' | 'error' } | null;
  showToast: (message: string, type?: 'info' | 'success' | 'error') => void;
  hideToast: () => void;
  currencyMode: CurrencyMode;
  setCurrencyMode: (m: CurrencyMode) => void;
}

export const useUI = create<UIState>((set) => ({
  activeTab: 'feed',
  setActiveTab: (t) => set({ activeTab: t }),
  toast: null,
  showToast: (message, type = 'info') => {
    set({ toast: { message, type } });
    setTimeout(() => set({ toast: null }), 2500);
  },
  hideToast: () => set({ toast: null }),
  currencyMode: loadCurrencyMode(),
  setCurrencyMode: (m) => {
    try { localStorage.setItem(CURRENCY_KEY, m); } catch { /* ignore */ }
    set({ currencyMode: m });
  },
}));
